export function previewInput(text) {
  return `{{${String(text ?? '')}}}`;
}

export const PREVIEW_INPUT_PATTERN = /(\{\{[\s\S]*?\}\})/g;

export function isPreviewInputPart(part) {
  return part.startsWith('{{') && part.endsWith('}}');
}

export function unwrapPreviewInput(part) {
  if (isPreviewInputPart(part)) {
    return part.slice(2, -2);
  }
  return part;
}

export function stripPreviewInputMarkers(text) {
  return String(text ?? '').replace(/\{\{([\s\S]*?)\}\}/g, '$1');
}
